// What a coach can see, as toggles: meals, workouts, weight (weight off unless the student turns it on).
export const SHARE_ITEMS = [
  { key: 'meals', label: 'Bữa ăn', hint: 'Món, calo và đạm từng bữa' },
  { key: 'workouts', label: 'Tập luyện', hint: 'Buổi tập và calo đốt' },
  { key: 'weight', label: 'Cân nặng', hint: 'Chỉ cân nặng hiện tại' },
];

const TOGGLE = 'toggle border-base-300 bg-base-300 text-white checked:border-primary checked:bg-primary checked:text-white';

export default function CoachShares({ shares, onChange, disabled = false }) {
  return (
    <ul className="divide-y divide-line rounded-[20px] bg-base-100 px-4">
      <li className="py-3 text-sm text-muted">Coach luôn thấy tiến độ mục tiêu của bạn. Coach chỉ xem, không sửa được gì.</li>
      {SHARE_ITEMS.map((item) => (
        <li key={item.key}>
          <label className="flex min-h-14 items-center justify-between gap-3 py-2">
            <span>
              <span className="block text-[15px] font-medium">{item.label}</span>
              <span className="block text-xs text-muted">{item.hint}</span>
            </span>
            <input type="checkbox" className={TOGGLE} checked={!!shares[item.key]} disabled={disabled}
              onChange={(e) => onChange({ ...shares, [item.key]: e.target.checked })} />
          </label>
        </li>
      ))}
    </ul>
  );
}
